import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ENVIRONMENT_NAME } from '@freelancer/config';
import { TimeUtilsModule } from '@freelancer/time-utils';
import { CookieModule } from '@laurentgoudet/ngx-cookie';
import { environment } from 'environments/environment';
import { ErrorTracking } from './error-tracking.service';
import { FacebookPixelTracking } from './facebook-pixel-tracking.service';
import { GoogleTracking } from './google-tracking.service';
import { HeartbeatTrackingComponent } from './heartbeat-tracking.component';
import { MemoryLeakTrackingComponent } from './memory-leak-tracking.component';
import { NavigationPerformanceTrackingComponent } from './navigation-performance-tracking.component';
import { PageViewTrackingComponent } from './page-view-tracking.component';
import { PerformanceTracking } from './performance-tracking.service';
import { SpinnerHeartbeatDirective } from './spinner-heartbeat.directive';
import { SyntheticPerformanceTrackingComponent } from './synthetic-performance-tracking.component';
import { TrackingSectionDirective } from './tracking-section.directive';
import { TrackingComponent } from './tracking.component';
import { TRACKING_CONFIG } from './tracking.config';
import { TrackingDirective } from './tracking.directive';
import { TrackingConfig } from './tracking.interface';
import { Tracking } from './tracking.service';
import { UserTimingTrackingComponent } from './user-timing-tracking.component';

@NgModule({
  imports: [HttpClientModule, CookieModule, TimeUtilsModule],
  declarations: [
    HeartbeatTrackingComponent,
    MemoryLeakTrackingComponent,
    NavigationPerformanceTrackingComponent,
    PageViewTrackingComponent,
    SyntheticPerformanceTrackingComponent,
    SpinnerHeartbeatDirective,
    TrackingComponent,
    TrackingDirective,
    TrackingSectionDirective,
    UserTimingTrackingComponent,
  ],
  exports: [
    TrackingComponent,
    SpinnerHeartbeatDirective,
    TrackingDirective,
    TrackingSectionDirective,
    HeartbeatTrackingComponent,
  ],
  providers: [
    ErrorTracking,
    PerformanceTracking,
    GoogleTracking,
    FacebookPixelTracking,
  ],
  // Exported to GAF
  entryComponents: [TrackingComponent],
})
export class TrackingModule {
  static initialize(config: TrackingConfig): ModuleWithProviders {
    return {
      ngModule: TrackingModule,
      providers: [
        Tracking,
        { provide: TRACKING_CONFIG, useValue: config },
        { provide: ENVIRONMENT_NAME, useValue: environment.environmentName },
      ],
    };
  }
}
